module.exports = __webpack_public_path__ + "img/kilbi-bg5.dd48970f.jpg";